import { Bot } from "lucide-react";
import WalterQuestionsPanel from "@/components/admin/WalterQuestionsPanel";
import WalterFactsPanel from "@/components/admin/WalterFactsPanel";

export default function MeinWalter() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 space-y-6" data-testid="mein-walter-page">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground">
          <Bot className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Mein Walter</h1>
          <p className="text-sm text-muted-foreground">
            Support-Assistent verwalten: offene Fragen beantworten und WALTERs Wissen pflegen.
          </p>
        </div>
      </div>

      <WalterQuestionsPanel defaultOpen />
      <WalterFactsPanel />
    </div>
  );
}
